// Read-only sharing controls: pick which Assessores Espirituais can see the schedule.
export const SharePanel = ({ assessors, sharedIds, toggleAssessor }) => (
  <div className="mt-10 bg-white border border-[hsl(var(--border))] p-6 lg:p-8" data-testid="spiritual-share-block">
    <div className="overline">Partilha com o Assessor Espiritual</div>
    <p className="mt-3 text-sm text-[hsl(var(--muted-foreground))] leading-relaxed">
      Pode escolher um ou mais Assessores Espirituais para acederem em modo apenas-leitura ao seu Horário Espiritual e Exame Particular. Pode reverter a partilha a qualquer momento.
    </p>
    {assessors.length === 0 ? (
      <p className="mt-4 text-xs italic text-[hsl(var(--muted-foreground))]">
        Não há Assessores Espirituais definidos atualmente.
      </p>
    ) : (
      <ul className="mt-5 space-y-2" data-testid="spiritual-assessor-list">
        {assessors.map((ax) => {
          const on = sharedIds.includes(ax.id);
          return (
            <li key={ax.id} className="flex items-center justify-between gap-3 p-3 border border-[hsl(var(--border))]" data-testid={`spiritual-assessor-${ax.id}`}>
              <div className="flex items-center gap-3 min-w-0">
                {ax.picture ? (
                  <img src={ax.picture} alt={ax.name} className="h-9 w-9 rounded-full object-cover" />
                ) : (
                  <div className="h-9 w-9 rounded-full bg-[hsl(var(--secondary))] flex items-center justify-center text-xs font-medium">
                    {(ax.name || "?").slice(0, 1).toUpperCase()}
                  </div>
                )}
                <div className="min-w-0">
                  <div className="text-sm font-medium truncate">{ax.name}</div>
                  <div className="text-[11px] text-[hsl(var(--muted-foreground))] truncate">{ax.email}</div>
                </div>
              </div>
              <label className="flex items-center gap-2 cursor-pointer shrink-0">
                <input type="checkbox" checked={on} onChange={(e) => toggleAssessor(ax.id, e.target.checked)}
                  className="h-4 w-4" data-testid={`spiritual-assessor-toggle-${ax.id}`} />
                <span className="text-[10px] uppercase tracking-[0.18em] text-[hsl(var(--muted-foreground))]">
                  {on ? "Partilhado" : "Partilhar"}
                </span>
              </label>
            </li>
          );
        })}
      </ul>
    )}
  </div>
);
